import "../../stylesheets/App.css";
import "../../stylesheets/SliderStages.css";
import React, { useState, useEffect } from "react";
import StageItem from "./StageItem.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Link } from "react-router-dom";

function SliderStages(props) {
  const [stages, setStages] = useState([]);

  const apiCall = (url, onSuccess) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => onSuccess(data))
      .catch((error) => console.log(error));
  };

  const updateStages = (data) => {
    setStages(data.data || []);
    props.setLoadingStages?.(false);
  };

  useEffect(() => {
    apiCall(
      process.env.REACT_APP_API_BASE_URL + "/stages/inProcessList",
      updateStages
    );
  }, []);

  const slideLeft = () => {
    const slider = document.getElementById("slider");
    const firstItem = document.getElementsByClassName("stage-item-container")[0];
    if (!slider || !firstItem) return;

    const distancia = firstItem.clientWidth;

    slider.scrollLeft =
      slider.scrollLeft + slider.clientWidth === slider.scrollWidth
        ? slider.scrollLeft - distancia
        : slider.scrollLeft - distancia - 20;
  };

  const slideRight = () => {
    const slider = document.getElementById("slider");
    const firstItem = document.getElementsByClassName("stage-item-container")[0];
    if (!slider || !firstItem) return;

    const distancia = firstItem.clientWidth;
    slider.scrollLeft = slider.scrollLeft + distancia + 20;
  };

  return (
    <>
      <div className="relative flex items-center slider-flex-custom">
        <FontAwesomeIcon
          icon={solid("chevron-left")}
          className="opacity-50 cursor-pointer hover:opacity-100"
          onClick={slideLeft}
          size={"sm"}
        />

        <div
          id="slider"
          className="w-full h-full overflow-x-scroll scroll whitespace-nowrap scroll-smooth scrollbar-hide"
        >
          {stages.map((item) => {
            const route = item.active === 1 ? "/stage/" + item.idStage : "";

            return (
              <React.Fragment key={"stage-" + item.idStage}>
                {route ? (
                  <Link to={route}>
                    <StageItem stage={item} is_stage={true} />
                  </Link>
                ) : (
                  <StageItem stage={item} is_stage={true} />
                )}
              </React.Fragment>
            );
          })}
        </div>

        <FontAwesomeIcon
          icon={solid("chevron-right")}
          className="opacity-50 cursor-pointer hover:opacity-100"
          onClick={slideRight}
          size={"sm"}
        />
      </div>
    </>
  );
}

export default SliderStages;
